import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';

import { useCocktailContext, useFlavoursContext } from '@hooks';
import DrinkHistoryCard from '@components/DrinkHistoryCard';
import { HeaderLayout } from '@layouts';

import { useStyles } from './styles';

function DrinksHistoryScreen() {
  const classes = useStyles();
  const { t } = useTranslation('drinksHistory');

  // ? Temporary.
  // ? For layout of drinks history screen
  // ? used list of recommended cocktails
  const { flavoursList } = useFlavoursContext();
  const {
    fetchRecommendedCocktailsList,
    // fetchedRecommendedCocktailsMap,
  } = useCocktailContext();

  useEffect(() => {
    fetchRecommendedCocktailsList({
      flavoursList,
      successfulRedirecting: () => {},
      failedRedirecting: () => {},
    });
  }, []); // eslint-disable-line

  // const drinkedCocktailTitleList = [
  //   'The Other Woman',
  //   'Los Pollos Hermanos',
  //   'Margarita',
  //   'Frozen Mango Daiquiri',
  //   'Old Fashioned',
  // ];

  // const drinkedCocktailList =
  //   fetchedRecommendedCocktailsMap &&
  //   fetchedRecommendedCocktailsMap.recommendation &&
  //   fetchedRecommendedCocktailsMap.recommendation.results &&
  //   fetchedRecommendedCocktailsMap.recommendation.results
  //     .filter(({ productName }) =>
  //       drinkedCocktailTitleList.some(item => item === productName),
  //     )
  //     .map(({ id, image_url, productName }) => ({
  //       id,
  //       image_url,
  //       productName,
  //     }));

  return (
    <HeaderLayout title={t('title')}>
      <Box className={classes.content}>
        {/* {drinkedCocktailList &&
          drinkedCocktailList.map(({ id, image_url, productName }) => {
            return (
              <DrinkHistoryCard
                key={id}
                srcImg={image_url}
                title={productName}
              />
            );
          })} */}
        <DrinkHistoryCard />
        <DrinkHistoryCard />
        <DrinkHistoryCard />
        <DrinkHistoryCard />
        <DrinkHistoryCard />
      </Box>
    </HeaderLayout>
  );
}

export default DrinksHistoryScreen;
